<template>
  <v-skeleton-loader v-if="loading" type="chip"></v-skeleton-loader>

  <v-chip
    v-else-if="aiCase"
    color="deep-purple"
    dark
    label
    class="ai-case-chip"
  >
    <div class="d-flex flex-column align-start py-1">
      <span class="font-weight-medium">{{ aiCase.label }}</span>
      <span v-if="aiCase.openedAt" class="ai-case-chip__opened">
        Открыт {{ openedAt }}
      </span>
    </div>
  </v-chip>
</template>

<script>
import { formatTimestampToHumanReadableDate } from '@/lib/utils';

export default {
  name: 'AiCaseIndicator',

  props: {
    aiCase: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    openedAt() {
      return formatTimestampToHumanReadableDate(this.aiCase.openedAt);
    },
  },
};
</script>

<style scoped lang="scss">
.ai-case-chip {
  height: auto;
  line-height: 1.2;

  &__opened {
    font-size: 0.7rem;
    opacity: 0.85;
  }
}
</style>
